import {apiRequest} from "@/services/api/apiClient.js";

export async function getCities({ page = 1, limit = 10, ...filters } = {}) {
    return apiRequest({
        client: window.API_CONTRACT,
        method: "get",
        url: "/city",
        params: { page, limit, ...filters },
    });
}
